export function toKebabCase(str: string) {
    return str
        .replaceAll(/[_\s]+/g, '-')
        .replaceAll(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replaceAll(/([A-Z])([A-Z][a-z])/g, '$1-$2')
        .replaceAll(/[^a-zA-Z0-9-]+/g, '')
        .toLowerCase();
}
